import { styled } from '@linaria/react'

const Row = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

export default Row;
